import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import toast from 'react-hot-toast';

const LEAD_SOURCES_KEY = ['leadSources'];

export const useLeadSources = () => {
    const queryClient = useQueryClient();

    const { data: leadSources, isLoading, error } = useQuery({
        queryKey: LEAD_SOURCES_KEY,
        queryFn: () => api.get('/company/lead-sources').then(res => res.data.data || []),
    });

    const createMutation = useMutation({
        mutationFn: (newSource) => api.post('/company/lead-sources', newSource),
        onSuccess: () => {
            toast.success('Lead source created successfully');
            queryClient.invalidateQueries(LEAD_SOURCES_KEY);
        },
        onError: () => toast.error('Failed to create lead source'),
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => api.put(`/company/lead-sources/${id}`, data),
        onSuccess: () => {
            toast.success('Lead source updated successfully');
            queryClient.invalidateQueries(LEAD_SOURCES_KEY);
        },
        onError: () => toast.error('Failed to update lead source'),
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => api.delete(`/company/lead-sources/${id}`),
        onSuccess: () => {
            toast.success('Lead source deleted successfully');
            queryClient.invalidateQueries(LEAD_SOURCES_KEY);
        },
        onError: () => toast.error('Failed to delete lead source'),
    });

    return {
        leadSources,
        isLoading,
        error,
        createLeadSource: createMutation.mutate,
        updateLeadSource: updateMutation.mutate,
        deleteLeadSource: deleteMutation.mutate,
        isCreating: createMutation.isPending,
        isUpdating: updateMutation.isPending,
        isDeleting: deleteMutation.isPending,
    };
};
